import { centreAddress } from './get-centre-structured-data'
import { formatISOWithTime } from './date-format-helpers'
import { firstOccurrence, lastOccurrence, getOccurrences } from './occurrences'
import { fullCentreTitle } from './full-centre-title'

import getImageFromEntry from './get-image-from-entry'

const maybeAddHttps = url =>
  url && (url.startsWith('//') ? `https:${url}` : url)

const occurrencesHasTimes = occurrences =>
  occurrences && occurrences.times && occurrences.times.length > 0

export const getStructureDataGqlV2 = (entries, entryType, centre) => {
  switch (entryType) {
    case 'Event': {
      return entries.map(entry => ({
        ...entry,
        name: entry.title,
        category: 'Event',
        occurrences: getOccurrences(
          true,
          { ...entry, occurrences: entry.occurrencesCollection.items },
          centre.timeZone
        ),
        image: getImageFromEntry(entry),
      }))
    }
    default:
      return null
  }
}

export default function getEntryStructuredData({ entry, centre, url }) {
  if (entry && entry.category !== 'Event') {
    // todo:
    // Until we implement the other entry types, continue to yield no
    // structured data for them, per SEO partner recommendations
    return {}
  }
  if (!entry || !centre || !url) {
    // If we can't make a complete set of structured data, don't
    // override earlier calls which could
    return null
  }
  const extremalDate = occurenceSelector =>
    occurrencesHasTimes(entry.occurrences)
      ? formatISOWithTime(
          occurenceSelector(entry.occurrences.times, entry.occurrences.timeZone)
        )
      : undefined
  const startDate = extremalDate(firstOccurrence)
  const endDate = extremalDate(lastOccurrence)
  return {
    '@context': 'http://schema.org',
    '@type': entry.category,
    name: entry.title,
    startDate,
    endDate,
    location: {
      '@type': 'Place',
      name: fullCentreTitle(centre),
      address: centreAddress(centre),
    },
    image: [entry.image ? maybeAddHttps(entry.image.src) : null],
    description: entry.shortDescription,
    url,
  }
}
